import React, { useState } from 'react';

const galleryImages = [
  // Campus / College Building
  { id: 1, src: '/college-building.jpeg', category: 'Campus', title: 'College Campus' },
  { id: 2, src: '/college-banner.jpeg', category: 'Campus', title: 'PCN Main Block' },

  // Auditorium
  {
    id: 3,
    src: '/gallery-auditorium.jpg',
    category: 'Auditorium',
    title: 'Main Auditorium',
  },

  // Classroom & Labs
  {
    id: 4,
    src: '/nursing-classroom-banner.jpg',
    category: 'Classroom & Labs',
    title: 'Interactive Lecture Hall',
  },
  {
    id: 5,
    src: '/lab-foundation.jpg',
    category: 'Classroom & Labs',
    title: 'Nursing Foundation Lab',
  },
  {
    id: 6,
    src: '/lab-advanced.jpg',
    category: 'Classroom & Labs',
    title: 'Simulation & Skills Lab',
  },

  // Hospital
  {
    id: 7,
    src: '/nursing-clinical-banner.jpg',
    category: 'Hospital',
    title: 'Hospital Ward Training',
  },

  // Hostels
  {
    id: 8,
    src: '/gallery-hostel.jpg',
    category: 'Hostels',
    title: 'Hostel Rooms',
  }
];

const categories = ['All', 'Campus', 'Auditorium', 'Classroom & Labs', 'Hospital', 'Hostels'];

function Gallery() {
  const [filter, setFilter] = useState('All');
  const [lightbox, setLightbox] = useState(null);

  const filtered = filter === 'All' ? galleryImages : galleryImages.filter((img) => img.category === filter);

  return (
    <section id="gallery" className="gallery-section">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title">
             Photo Gallery
          </h2>
          <div className="gold-underline"></div>
          <p className="section-subtitle">A Glimpse into Life at Paramananda College of Nursing</p>
        </div>

        <div className="gallery-filters">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-btn ${filter === cat ? 'active' : ''}`}
              onClick={() => setFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="gallery-grid">
          {filtered.map((img) => (
            <div key={img.id} className="gallery-item" onClick={() => setLightbox(img)}>
              <img src={img.src} alt={img.title} loading="lazy" />
              <div className="gallery-overlay">
                <h4>{img.title}</h4>
                <span>{img.category}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div className="lightbox-overlay" onClick={() => setLightbox(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setLightbox(null)}>✕</button>
            <img src={lightbox.src} alt={lightbox.title} />
            <p>{lightbox.title} — {lightbox.category}</p>
          </div>
        </div>
      )}
    </section>
  );
}

export default Gallery;